import styled from 'styled-components';

export const QStyled = styled.q`
  font-family: Arial, Helvetica, sans-serif;
`;

export const Container = styled.div`
  font-style: italic;
  font-size: 1.3rem;
  margin: 1rem auto 0;
  max-width: 600px;
  text-align: center;
`;
